import { v4 as uuid } from 'uuid';

export const DEFAULT_CONDITION = {
  id: uuid(),
  ChecklistItemId: '',
  logic: null,
  value: null,
  order: 0,
};

export const getChecklistItemsHash = (items: any[]) => {
  if (!items) return {};
  const hash: any = {};
  items?.forEach((item) => {
    hash[item.id] = item;
    if (item?.ChildItems) {
      Object.assign(hash, getChecklistItemsHash(item?.ChildItems));
    }
  });
  return hash;
};

export const generateOrder = (items, parentOrder = '', orders = {}) => {
  let number = 0;
  items?.forEach((item) => {
    if (item?.type !== 'header') {
      number++;
      const currentOrder = parentOrder
        ? `${parentOrder}.${number}`
        : `${number}`;
      orders[item?.id] = currentOrder;

      if (item?.ChildItems && item?.ChildItems?.length > 0) {
        generateOrder(item?.ChildItems, currentOrder, orders);
      }
    }
  });
  return orders;
};

export const convertAutomationIntoCondition = (automation) => {
  return {
    condition: {
      logic: automation?.conditions?.[0]?.logic,
      value: automation?.conditions?.[0]?.value,
    },
    context: 'isFilled',
    contextId: automation?.EntityId,
  };
};

export const compareVersions = (a, b) => {
  if (a === null && b === null) return 0;
  if (a === null) return 1; // Null values come last
  if (b === null) return -1;

  // Split by dots and convert to numbers
  const aParts = a.split('.').map(Number);
  const bParts = b.split('.').map(Number);

  // Compare each part
  for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
    // If a part doesn't exist, treat it as 0
    const aPart = i < aParts.length ? aParts[i] : 0;
    const bPart = i < bParts.length ? bParts[i] : 0;

    if (aPart !== bPart) {
      return aPart - bPart;
    }
  }

  return 0;
};
